<template>
    <button
        :class="open ? '' : 'text-opacity-90'"
        @click="toggle"
        class="h-input inline-flex items-center px-3 py-2 text-base font-medium text-white border-cyan-600 bg-cyan-600 rounded-tl-md hover:bg-cyan-700 rounded-bl-md group hover:text-opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
    >
        <FunnelIcon
            :class="open ? '' : 'text-opacity-70'"
            class="w-5 h-5 ml-2 text-white0 transition duration-150 ease-in-out group-hover:text-opacity-80"
            aria-hidden="true"></FunnelIcon>
        <ChevronDownIcon
            :class="open ? '' : 'text-opacity-70'"
            class="w-5 h-5 ml-2 text-white0 transition duration-150 ease-in-out group-hover:text-opacity-80"
            aria-hidden="true"
        />
    </button>

    <OverlayPanel ref="op" :breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '450px'}">
        <slot></slot>
    </OverlayPanel>
</template>

<script>
import {Popover, PopoverButton, PopoverPanel} from '@headlessui/vue'
import {ChevronDownIcon} from '@heroicons/vue/20/solid'
import {FunnelIcon} from "@heroicons/vue/24/outline";
import {ref} from "vue";

export default {
    components: {Popover, PopoverButton, PopoverPanel, ChevronDownIcon, FunnelIcon},

    setup() {
        const open = ref(false);

        return {
            open
        }
    },
    methods: {
        toggle(event) {
            this.open = !this.open;
            this.$refs.op.toggle(event);
        },
    }
}
</script>
